<template>
  <div class="row reverse-mobile justify-content-center">
    <div class="col-12 col-md-3 filters-section left-menu">
      <MyGroupsMini :selected-group-id="groupId"></MyGroupsMini>
    </div>

    <div class="center-content col-12 col-md-6">
      <div class="mb-3">
        <CreateForumPost
          v-on:reload-data="initialise()"
          :isGroup="true"
          :groupId="groupObj.id"
        />
      </div>

      <PleaseWait v-if="isLoading" />

      <template v-else>
        <div v-if="myPendingPosts.length" class="mb-3">
          <h4>My Pending Posts</h4>

          <ul class="list-style-none">
            <li class="my-2" v-for="post in myPendingPosts" :key="post.id">
              <ForumPost v-on:reload-data="initialise()" :postObj="post" />
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <ul v-if="approvedPosts.length" class="list-style-none">
            <div class="results-count mb-2 ml-1">
              {{ approvedPosts.length }}
              Post{{ approvedPosts.length != 1 ? "s" : "" }} Available
            </div>

            <li v-for="post in approvedPosts" :key="post.id">
              <ForumPost v-on:reload-data="initialise()" :postObj="post" />
            </li>
          </ul>
          <div v-else>No posts in group</div>
        </div>
      </template>
    </div>

    <div class="col-12 col-md-3 right-menu mb-3">
      <CommunityCard :withHorizontalRules="true">
        <template #header>
          <div class="isim-community-card-header justify-content-between">
            <h5>{{ groupObj.name }}</h5>

            <router-link v-if="isGroupAdmin" :to="'/forum/edit/' + groupObj.id">
              <button class="btn btn-primary ml-2 flex-grow">Manage</button>
            </router-link>
          </div>
        </template>

        <div class="community-card-content">
          <div v-if="groupObj.description && groupObj.description !== 'a'">
            {{ groupObj.description }}
          </div>
        </div>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import ForumGroupService from "../services/forumgroup.service";
import CreateForumPost from "../components/CreateForumPost/CreateForumPost";
import ForumPost from "../components/ForumPost";
import MyGroupsMini from "../components/MyGroupsMini";
import CommunityCard from "../components/CommunityCard";
import PleaseWait from "@/components/PleaseWait";

const MEMBER_TYPES = {
  Member: 0,
  Moderator: 1,
  Creator: 2,
};

export default {
  name: "ForumGroup",
  components: {
    PleaseWait,
    CreateForumPost,
    ForumPost,
    MyGroupsMini,
    CommunityCard,
  },
  data: function () {
    return {
      groupObj: {},
      posts: [],
      isSubmitting: false,
      allGroups: [],
      isGroupAdmin: false,
      isLoading: false,
    };
  },
  created() {
    this.initialise();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("createForumPostStore/closeModal");
    next();
  },
  computed: {
    myPendingPosts() {
      let currentUserId = this.$store.getters.getUser.id;
      return this.posts.filter(
        (post) => post.creator.id === currentUserId && post.status === 0
      );
    },
    approvedPosts() {
      return this.posts.filter((post) => post.status === 1);
    },
    groupId() {
      return +this.$route.params.groupId;
    },
  },
  methods: {
    initialise() {
      this.isLoading = true;

      Promise.all([
        ForumGroupService.getGroupPosts(this.groupId),
        ForumGroupService.getGroupDetailsWithoutMembers(this.groupId),
        ForumGroupService.myGroups(),
      ]).then((data) => {
        [this.posts, this.groupObj, this.allGroups] = data;

        const foundGroup = this.allGroups.find(
          (g) => g.id === this.groupObj.id
        );

        if (!foundGroup || !foundGroup.members.length) return false;

        const member = foundGroup.members[0];
        this.isGroupAdmin =
          member.member_type === MEMBER_TYPES.Moderator ||
          member.member_type === MEMBER_TYPES.Creator;
        
        this.isLoading = false;
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.initialise();
  },
};
</script>

<style scoped>
.community-card-content {
  margin: 1rem;
}

.results-count {
  color: var(--isim-light-text);
  font-size: 14px;
  text-align: start;
}

@media (max-width: 575.98px) {
  .filters-section .list-group {
    flex-wrap: wrap;
    justify-content: center;
  }
  .filters-section .list-group .list-group-item {
    min-width: 40%;
    max-width: 48%;
    border-radius: 0px !important;
  }
  .small-full {
    width: 100% !important;
  }
  .small-full div:first-child {
    text-align: center;
  }
  .upload-button {
    display: none;
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
    .pagination-wrapper {
      margin: 0px !important;
      padding: 0px !important;
      display: flex;
    }
    .pagination-wrapper ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}
</style>
